import { render } from "./KskIcon.vue?vue&type=template&id=1dadc1fe&scoped=true"
import script from "./KskIcon.vue?vue&type=script&lang=js"
export * from "./KskIcon.vue?vue&type=script&lang=js"

import "./KskIcon.vue?vue&type=style&index=0&id=1dadc1fe&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dadc1fe"]])

export default __exports__